import { render } from "./EventEditorPreviewSkeleton.vue?vue&type=template&id=a9b8effe&ts=true"
import script from "./EventEditorPreviewSkeleton.vue?vue&type=script&lang=ts"
export * from "./EventEditorPreviewSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__